import React, { useState } from 'react';
import { BookOpen, Headphones, Mic, PenTool } from 'lucide-react';
import { ComprehensionOraleManager } from './ComprehensionOraleManager';
import { ComprehensionEcriteManager } from './ComprehensionEcriteManager';
import { ExpressionOraleManager } from './ExpressionOraleManager';
import { ExpressionEcriteManager } from './ExpressionEcriteManager';

export const ContentManager = () => {
  const [activeModule, setActiveModule] = useState('comprehension-orale');

  const modules = [
    { id: 'comprehension-orale', label: 'Compréhension Orale', icon: Headphones, color: 'text-green-500' },
    { id: 'comprehension-ecrite', label: 'Compréhension Écrite', icon: BookOpen, color: 'text-blue-500' },
    { id: 'expression-orale', label: 'Expression Orale', icon: Mic, color: 'text-orange-500' },
    { id: 'expression-ecrite', label: 'Expression Écrite', icon: PenTool, color: 'text-purple-500' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold mb-2">Gestion de contenus</h2>
        <p className="text-muted-foreground">Gérez les questions et exercices pour chaque épreuve</p>
      </div>

      {/* Module Tabs */}
      <div className="flex flex-wrap gap-2 border-b pb-2">
        {modules.map((module) => {
          const Icon = module.icon;
          return (
            <button
              key={module.id}
              onClick={() => setActiveModule(module.id)}
              data-testid={`content-tab-${module.id}`}
              className={`flex items-center space-x-2 px-4 py-3 rounded-lg transition-colors ${
                activeModule === module.id
                  ? 'bg-primary text-primary-foreground font-medium'
                  : 'bg-secondary/50 text-muted-foreground hover:bg-secondary hover:text-foreground'
              }`}
            >
              <Icon className={`h-5 w-5 ${activeModule === module.id ? 'text-current' : module.color}`} />
              <span className="hidden md:inline">{module.label}</span>
            </button>
          );
        })}
      </div>

      {/* Content Area */}
      <div>
        {activeModule === 'comprehension-orale' && <ComprehensionOraleManager />}
        {activeModule === 'comprehension-ecrite' && <ComprehensionEcriteManager />}
        {activeModule === 'expression-orale' && <ExpressionOraleManager />}
        {activeModule === 'expression-ecrite' && <ExpressionEcriteManager />}
      </div>
    </div>
  );
};
